export const SERVICE_BASE_URL = ENV_SERVICE_BASE_URL;
export const SESSION_EXPIRED_REDIRECT = ENV_SESSION_EXPIRED_REDIRECT;


